import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import useAuthStore from '../../stores/useAuthStore';
import { useTranslation } from 'react-i18next';

const SignUp = () => {
   const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const {  register, loading, error,success,setUser,} = useAuthStore();

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
  };

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .required(t('login.register.firstNameRequired')),
    lastName: Yup.string()
      .required(t('login.register.lastNameRequired')),
    email: Yup.string()
      .email(t('login.register.emailInvalid'))
      .required(t('login.register.emailRequired')),
    password: Yup.string()
      .min(6, t('login.register.passwordMin'))
      .required(t('login.register.passwordRequired')),
  });

  const onSubmit = async (values) => {
    await register(values);
    console.log(values);
    
  };

  useEffect(() => {
    if (success) {
      navigate('/login');
    }
  }, [success, navigate]);



  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-100 text-black flex items-center justify-center px-4">
      <div className="w-full max-w-lg bg-white p-8 rounded-xl shadow-lg">
        <h2 className="text-center text-3xl font-bold mb-6">  { t('login.register.title')}</h2>

        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
          <Form className="space-y-4">
            <div className="flex gap-4">
              <div className="w-1/2">
                <label htmlFor="firstName" className="block text-sm font-medium mb-1"> { t('login.register.firstName')}</label>
                <Field
                  name="firstName"
                  type="text"
                  className="w-full px-4 py-2 bg-zinc-100 border border-zinc-300 rounded"
                  placeholder={ t('login.register.firstName')}
                />
                <ErrorMessage name="firstName" component="div" className="text-red-500 text-sm mt-1" />
              </div>

              <div className="w-1/2">
                <label htmlFor="lastName" className="block text-sm font-medium mb-1">{ t('login.register.lastName')}</label>
                <Field
                  name="lastName"
                  type="text"
                  className="w-full px-4 py-2 bg-zinc-100 border border-zinc-300 rounded"
                  placeholder={ t('login.register.lastName')}
                />
                <ErrorMessage name="lastName" component="div" className="text-red-500 text-sm mt-1" />
              </div>
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-1">{ t('login.register.email')} </label>
              <Field
                name="email"
                type="email"
                className="w-full px-4 py-2 bg-zinc-100 border border-zinc-300 rounded"
                placeholder="example@domain.com"
              />
              <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium mb-1">{ t('login.register.password')} </label>
              <Field
                name="password"
                type="password"
                className="w-full px-4 py-2 bg-zinc-100 border border-zinc-300 rounded"
                placeholder="********"
              />
              <ErrorMessage name="password" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            {/* Display API Error */}
            {error && <div className="text-red-600 text-sm text-center">{error}</div>}

            <button
              type="submit"
              className="w-full bg-primary hover:bg-primary/80 transition text-white font-semibold py-2 rounded"
              disabled={loading}
            >
            {loading ? 'جاري التسجيل...' : t('login.register.createButton')}

            </button>

            <div className="border-t border-gray-200 my-6"></div>

            <p className="text-center text-sm text-gray-600 mt-4">
           { t('login.register.alreadyHaveAccount')}   {' '}
              <Link to="/login" className="text-blue-600 font-semibold underline">
                { t('login.register.loginLink')} 
              </Link>
            </p>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default SignUp;
